import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=20f70231&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"
import style0 from "./apply.vue?vue&type=style&index=0&id=20f70231&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f70231",
  null
  
)

export default component.exports